$('.price-per-item__container').append('<span class="basketBtn">カートに入れる</span>');
$('.price-per-item__container .basketBtn').on('click', function () {
    $('#new_product .product-form__submit').trigger('click');
});

// Shadow DOM 내부 요소는 document에 위임 + composedPath로 잡아야 함
document.addEventListener('click', function (e) {
    const path = e.composedPath();
    const target = path.find(el =>
        el.classList && el.classList.contains('rc-plans-button')
    );

    if (target) {
        e.preventDefault();
        $('#new_product .product-form__submit').trigger('click');
    }
});

function addBadgeAfterIcon() {
    const widget = document.querySelector('recharge-subscription-widget');

    // recharge-subscription-widget 존재 여부에 따라 클래스 토글
    const buttonsWrap = document.querySelector('#new_product .product-form__buttons');
    const prdQuantity = document.querySelector('.product-form__input');
    if (buttonsWrap) {
        buttonsWrap.classList.toggle('subs', !!widget);
    }
    if (prdQuantity) {
        prdQuantity.classList.toggle('subs', !widget);
    }

    // onetime 옵션이 선택(rc-selected)됐을 때만 quantity 노출
    if (prdQuantity) {
        let isOnetimeSelected = false;
        if (widget && widget.shadowRoot) {
            const onetimeOption = widget.shadowRoot.querySelector(
                '.rc-purchase-option.rc-selection__onetime'
            );
            isOnetimeSelected = !!(onetimeOption && onetimeOption.hasAttribute('rc-selected'));
        }
        prdQuantity.classList.toggle('is-visible', isOnetimeSelected);
    }

    if (!widget || !widget.shadowRoot) return false;

    const icons = widget.shadowRoot.querySelectorAll(
        '.rc-purchase-option__subscription .rc-purchase-option__selector'
    );

    if (!icons.length) return false;

    icons.forEach(icon => {
        const purchaseOption = icon.closest('.rc-purchase-option');

        // rc-not-selected가 있으면 배경 검정
        if (purchaseOption) {
            purchaseOption.style.backgroundColor =
                purchaseOption.hasAttribute('rc-not-selected')
                    ? '#e6e6e6'
                    : '';
            purchaseOption.style.border =
                purchaseOption.hasAttribute('rc-not-selected')
                    ? 'none'
                    : '';
        }
    });

    return true;
}

const widget = document.querySelector('recharge-subscription-widget');

if (widget && widget.shadowRoot) {
    const shadowObserver = new MutationObserver(addBadgeAfterIcon);

    shadowObserver.observe(widget.shadowRoot, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['part', 'rc-not-selected', 'rc-selected']
    });
}

const bodyObserver = new MutationObserver(addBadgeAfterIcon);

bodyObserver.observe(document.body, {
    childList: true,
    subtree: true
});

addBadgeAfterIcon();